<template>
  <section class="lead-flow-overview-section">
    <h3>Personal</h3>
    <dl>
      <div>
        <dt>First name</dt>
        <dd :title="value(personal.first_name)">{{ value(personal.first_name) }}</dd>
      </div>
      <div>
        <dt>Last name</dt>
        <dd :title="value(personal.last_name)">{{ value(personal.last_name) }}</dd>
      </div>
      <div>
        <dt>Language</dt>
        <dd :title="languageName">
          <span class="lead-flow-personal-details__language">
            <span
              v-if="languageFlagCode"
              :class="`fflag ff-sm fflag-${languageFlagCode}`"
              :aria-label="`${languageName} language`"
              class="lead-flow-personal-details__language-flag"
            ></span>
            <span>{{ languageName }}</span>
          </span>
        </dd>
      </div>
    </dl>
  </section>
</template>

<script>
const LANGUAGE_FLAG_COUNTRIES = {
  en: 'GB',
  english: 'GB',
  ru: 'RU',
  russian: 'RU',
  fr: 'FR',
  french: 'FR',
  de: 'DE',
  german: 'DE',
  it: 'IT',
  italian: 'IT',
  es: 'ES',
  spanish: 'ES',
  pt: 'PT',
  portuguese: 'PT',
  sw: 'TZ',
  swahili: 'TZ',
  zh: 'CN',
  chinese: 'CN',
  ar: 'SA',
  arabic: 'SA'
}

export default {
  name: 'LeadPersonalDetails',
  props: {
    personal: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    languageName() {
      const language = this.personal.language
      return language && language.name ? language.name : 'Not provided'
    },
    languageFlagCode() {
      const language = this.personal.language
      if (!language) return ''
      const explicitCode = this.normalizeCode(language.flag_country_code)
      if (explicitCode) return explicitCode.toUpperCase()
      const languageCode = String(language.code || '').trim().toLowerCase()
      const languageName = String(language.name || '').trim().toLowerCase()
      return LANGUAGE_FLAG_COUNTRIES[languageCode] || LANGUAGE_FLAG_COUNTRIES[languageName] || ''
    }
  },
  methods: {
    normalizeCode(value) {
      const code = String(value || '').trim()
      return /^[a-z]{2}$/i.test(code) ? code : ''
    },
    value(value) {
      return value || 'Not provided'
    }
  }
}
</script>

<style scoped>
.lead-flow-personal-details__language {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
}

.lead-flow-personal-details__language-flag {
  width: 23px;
  height: 14px;
  flex: 0 0 auto;
}
</style>
